module.exports = __webpack_public_path__ + "img/halo-qrcode.4d1b7519.png";